import styled from 'styled-components';
import { Title } from '../../theme/theme'

interface RelatedProductsShimmerImageCardProps {
    isOnModal?: boolean;
}

const RelatedProductsContainer = styled.section`
    display: flex;
    flex-direction: column;
    margin: 15px 1%;
    padding-bottom: 10px;
    box-sizing: border-box;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        justify-content: flex-start;
        align-items: baseline;
        width: 95%;
        box-sizing: border-box;
        flex-direction: row;
        display: inline-block;
        margin: 15px 0;
    }
        
`
const RelatedProductsScroll = styled.div`
    display: flex;
    justify-content: flex-start;
    overflow-x: scroll;
    margin: 5px 0;
    padding: 0 10px;
    ::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        margin: 0px;
        padding: 0 0;
    }
`


const RelatedProductTitlePage = styled(Title)`
    font-size: 1.5em;
    margin-top: 0px;
    margin-bottom: 10px;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        margin-left: 15px;
    }
`

const RelatedProductsShimmerContainer = styled.div`
  padding: 2rem;
  margin: 10px auto;
  background: #ffffff;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;

  @media (max-width: 38em) {
      //600px
      grid-template-columns: 1fr;
  }
`

const RelatedProductsShimmerWrapper = styled.div`
  animation: fullView 0.5s forwards linear;
  display: grid;
  justify-content: center;

    @media (max-width: 38em) {
      //600px
      margin-bottom:1rem;

  }
`

const RelatedProductsShimmerImageCard = styled.div<RelatedProductsShimmerImageCardProps>`

  width: ${({ isOnModal }) => (isOnModal ? '10rem' : '20rem')};
  height: ${({ isOnModal }) => (isOnModal ? '10rem' : '20rem')};
  border-radius: 8px;

    @media (max-width: 38em) {
      //600px
      //PHONES
      width: ${({ isOnModal }) => (isOnModal ? '10rem' : '15rem')};
      height: ${({ isOnModal }) => (isOnModal ? '10rem' : '15rem')};


  }

 @media (max-width: 80em) {
      //1200px
      width: ${({ isOnModal }) => (isOnModal ? '10rem' : '15rem')};
      width: ${({ isOnModal }) => (isOnModal ? '10rem' : '15rem')};
    }

    @media (max-width: 64em) {
      //1024
      width: 10rem;
      height: 10rem;
    }

`
const RelatedProductsShimmerDescriptionCardContainer = styled.div`
    display:flex;
    justify-content:center;

`

const RelatedProductsShimmerDescriptionCard = styled.div`
  width: 10rem;

`

export {
    RelatedProductsContainer,
    RelatedProductTitlePage,
    RelatedProductsScroll,
    RelatedProductsShimmerContainer,
    RelatedProductsShimmerWrapper,
    RelatedProductsShimmerImageCard,
    RelatedProductsShimmerDescriptionCardContainer,
    RelatedProductsShimmerDescriptionCard
}